import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TestCenterService } from '../services/test-center.service';

@Injectable({
  providedIn: 'root'
})
export class VueIdResolver {
  public constructor(
    private testCenterService: TestCenterService
  ) { }
  public resolve(): Observable<number> {
    return this.testCenterService.getVueId()
      .pipe(
        map((response) => response),
        catchError(() => {
          return of(null);
        })
      );
  }
}
